import React, { useState } from "react";
import { Select, Row, Col, Button } from "antd";

const PayTypeInput = (props: any) => {
  const { value, placeholder, onChange, dispatchOptions } = props;
  const [options, setOptions] = useState(
    dispatchOptions || [
      { id: "meter", name: "Meter" },
      { id: "now", name: "Now" },
    ]
  );

  return (
    <React.Fragment>
<div className="tiles padding-12">
          {/* <span className="col-label">{data?.label}</span> */}
      <Row className="mb-4">
      <Col span={6} className="d-flex align-items-center">
        {/* <h5 className="mb-0">Dispatch type</h5> */}
        <span className="col-label">Pay type</span>
        </Col>
        {options?.map((option, index) => (
          <Col span={6}>
            <Button
              onClick={() => {
                onChange({
                  value: option.id,
                  type: "payType",
                });
              }}
              className={`beam-btn ${
                value?.value === option.id ? "green-btn cover" : ""
              }`}
            >
              {option.name}
            </Button>
          </Col>
        ))}
      </Row>
      </div>
    </React.Fragment>
  );
};

export default PayTypeInput;
